import { delegate } from '../utils/delegate.js';
import { injectDom } from 'utils/injectDom';

/**
 * Replaces page contents with the results of a form submission. When the form specified
 * is provided, the content of 'targetSelector' will be replaced with the contents of
 * 'targetSelector' from the AJAX response of the form. Forms should be set up as
 * Rails remote forms (with remote: true)
 *
 * - formSelector - the selector of forms that should be listened to for replacement
 * - targetSelector - The selector indicating which content should be replaced
 */
export function partialReplacementForm({ formSelector, targetSelector }) {
  delegate({
    selector: formSelector,
    eventName: 'ajax:success',
    handler: (e) => {
      const title = e.detail[0].querySelector('title').innerText;
      const replacementDom = e.detail[0].querySelector(targetSelector);
      const target = document.querySelector(targetSelector);

      injectDom(target, replacementDom);

      window.history.pushState({}, title, e.detail[2].responseURL);
      window.supercast.trigger('pageload');
    }
  })
}

